const apiUrl = process.env.REACT_APP_BASE_URL;
export const BASEURL = apiUrl + 'api/v1/';
// export const BASEURL = 'http://localhost:8000/' + 'api/v1/';
// export const BASEURL = 'https://stage-api.quickaction.ai/' + 'api/v1/';
